export default __webpack_public_path__ + "static/media/card12.6159018f.png";